<template>
  <div>
    <!-- Desktop Toolbar -->
    <v-toolbar flat color="white" class="hidden-sm-and-down">
      <v-toolbar-title>Ürünler</v-toolbar-title>
      <v-divider class="mx-3" inset vertical></v-divider>
      
      <!-- Tenant Seçimi -->
      <v-select
        v-model="selectedTenantId"
        :items="tenantOptions"
        item-text="tenantName"
        item-value="tenantId"
        label="Tenant Seç"
        @change="onTenantChange"
        style="min-width: 150px; margin-right: 10px; margin-top: 20px;"
        
      ></v-select>
      <v-divider class="mx-2" inset vertical></v-divider>
      
      <v-text-field v-model="search" append-icon="search" label="Ara" single-line hide-details></v-text-field>
      <v-divider class="mx-2" inset vertical></v-divider>
      <v-combobox
        v-model="select"
        :items="items"
        item-value="id"
        item-text="value" 
        @change="initialize"
        hide-details
        label="Aktif/Pasif"
      ></v-combobox>
      <v-divider class="mx-2" inset vertical></v-divider>
      <v-combobox
        v-model="selectCategory"
        :items="categoryItems"
        item-value="id"
        @change="initialize"
        item-text="value"
        hide-details
        label="Kategori"
      ></v-combobox>
      <v-divider class="mx-2" inset vertical></v-divider>
      <v-select
          v-model="selectSiteCategory"
          :items="siteCategoryItems"
          item-value="key"
          item-text="name"
          hide-details
          label="Site Kategori"
          clearable
      ></v-select>
      <v-divider class="mx-2" inset vertical></v-divider>
      <v-btn
        :color="onlyInstallment ? 'deep-purple darken-1' : ''"
        :dark="onlyInstallment"
        :outlined="!onlyInstallment"
        small
        rounded
        class="mb-2 mr-2"
        style="text-transform: none; min-width: 130px;"
        @click="onlyInstallment = !onlyInstallment"
      >
        <v-icon left small>{{ onlyInstallment ? 'check_circle' : 'event_repeat' }}</v-icon>
        Taksitliler
      </v-btn>
      <v-btn color="primary" dark @click="initialize" class="mb-2">Ara</v-btn>
      <v-btn color="primary" dark class="mb-2" to="/admin/product/detail">Yeni Ekle</v-btn>
    </v-toolbar>

    <!-- Mobile Toolbar -->
    <div class="hidden-md-and-up mobile-toolbar">
      <v-card flat>
        <v-card-title class="pb-2">
          <span class="headline">Ürünler (Admin)</span>
          <v-spacer></v-spacer>
          <v-btn icon color="primary" to="/admin/product/detail">
            <v-icon>add</v-icon>
          </v-btn>
        </v-card-title>
        
        <v-card-text class="pt-0">
          <!-- Tenant Seçimi - Mobil -->
          <v-select
            v-model="selectedTenantId"
            :items="tenantOptions"
            item-text="tenantName"
            item-value="tenantId"
            label="Tenant Seç"
            @change="onTenantChange"
            outlined
            dense
            class="mb-2"
          ></v-select>
          
          <!-- Arama - Mobil -->
          <v-text-field 
            v-model="search" 
            append-icon="search" 
            label="Ara" 
            outlined
            dense
            hide-details
            class="mb-2"
          ></v-text-field>
          
          <!-- Filtreler - Mobil -->
          <v-row>
            <v-col cols="6">
              <v-select
                v-model="select"
                :items="items"
                item-value="id"
                item-text="value" 
                @change="initialize"
                label="Aktif/Pasif"
                outlined
                dense
                hide-details
              ></v-select>
            </v-col>
            <v-col cols="6">
              <v-select
                v-model="selectCategory"
                :items="categoryItems"
                item-value="id"
                @change="initialize"
                item-text="value"
                label="Kategori"
                outlined
                dense
                hide-details
              ></v-select>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-select
                v-model="selectSiteCategory"
                :items="siteCategoryItems"
                item-value="key"
                item-text="name"
                label="Site Kategori"
                outlined
                dense
                hide-details
              ></v-select>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-checkbox
                v-model="onlyInstallment"
                label="🔁 Sadece Taksitli Ürünler"
                hide-details
                dense
              ></v-checkbox>
            </v-col>
          </v-row>

          <!-- Ara Butonu - Mobil -->
          <v-btn 
            color="primary" 
            dark 
            @click="initialize" 
            block 
            class="mt-3"
          >
            <v-icon left>search</v-icon>
            Ara
          </v-btn>
        </v-card-text>
      </v-card>
    </div>
    <v-data-table
      :headers="headers"
      :loading="this.$store.state.progress"
      :rows-per-page-items="pageItems"
      :items="filteredProducts"
      :pagination.sync="pagination"
      :search="search"
      class="elevation-1"

    >
      <template v-slot:headers="props">
        <tr>
          <th
            v-for="header in props.headers"
            :key="header.text"
            class="px-0 text-xs-center"
            :class="['column sortable', pagination.descending ? 'desc' : 'asc', header.value === pagination.sortBy ? 'active' : '']"
            @click="changeSort(header.value)"
          >
            {{ header.text }}
            <v-icon small>arrow_upward</v-icon>
          </th>
        </tr>
      </template>
      <template v-slot:items="props">
        <td class="px-0 text-xs-center">{{ props.item.id }}</td>
        <td class="px-0 text-xs-center">{{ props.item.sku }}</td>
        <td class="px-0 text-xs-center">{{ props.item.brand }}</td>
        <td class="px-0 text-xs-center">{{ props.item.name }}</td>
        <td class="px-0 text-xs-center" v-if="props.item.stock">{{ props.item.stock.productName }}</td>
        <td class="px-0 text-xs-center" v-if="!props.item.stock"></td>
        <td class="px-0 text-xs-center" v-if="props.item.productCategory">{{ props.item.productCategory.name }}</td>
        <td class="px-0 text-xs-center" v-if="!props.item.productCategory"></td>
        <td class="px-0 text-xs-center">{{ getSiteCategoryText(props.item) }}</td>
        <td class="px-0 text-xs-center">{{ props.item.availableStock }}</td>
        <td class="px-0 text-xs-center">{{ props.item.listPrice }}</td>
        <td class="px-0 text-xs-center">{{ props.item.price }}</td>
        <td class="px-0 text-xs-center">{{ props.item.purchasePrice }}</td>
        <td class="px-0 text-xs-center" v-if="props.item.state==1">Aktif</td>
        <td class="px-0 text-xs-center" v-else>Pasif</td>
        <td class="px-0 text-xs-center">
          <v-icon small class="mr-2" @click="editItem(props.item)">edit</v-icon>
          <v-icon small @click="deleteItem(props.item)">delete</v-icon>
        </td>
      </template>
      <template v-slot:no-data>
        <v-btn color="primary" @click="initialize">Reset</v-btn>
      </template>
    </v-data-table>
  </div>
</template>
<script>
export default {
  data: () => ({
    selectedTenantId: null,
    tenantOptions: [
      { tenantId: 1, tenantName: "Altinda Firsat" },
      { tenantId: 2, tenantName: "EAltin" }
    ],
    pagination: {
      sortBy: "name"
    },
    select: { id: -1, value: "Tümü" },
    selectCategory: { id: 0, value: "Tümü" },
    selectSiteCategory: null,
    onlyInstallment: false,
    search: null,
    pageItems: [
      500,
      1000,
      { text: "$vuetify.dataIterator.rowsPerPageAll", value: -1 }
    ],
    items: [
      { id: -1, value: "Tümü" },
      { id: false, value: "Pasif" },
      { id: true, value: "Aktif" }
    ],
      categoryItems: [
      { id: -1, value: "Tümü" },
      { id: 1, value: "çeyrek altın" },
      { id: 2, value: "yarım altın" },
      { id: 3, value: "tam altın" },
      { id: 4, value: "ata lira" },
      { id: 5, value: "24 ayar gram altın" },
      { id: 6, value: "22 ayar gram altın" },
      { id: 7, value: "Gremse ve Arma" },
      { id: 8, value: "Bilezik grubu" }
    ],
    headers: [
      {
        text: "Id",
        align: "left",
        value: "id"
      },
      { text: "Kod", value: "sku" },
      { text: "Marka", value: "brand" },
      { text: "Ürün", value: "name" },
      { text: "Stok Adı", value: "stock.productName" },
      { text: "Ana Kategori", value: "productCategory.name" },
      { text: "Site Kategori", value: "categoryKey" },
      { text: "Stok", value: "availableStock" },
      { text: "Liste Fiyatı", value: "listPrice" },
      { text: "Satış Fiyatı", value: "price" },
      { text: "Alış Fiyatı", value: "purchasePrice" },
      { text: "Durum", value: "state" },
      { text: "İşlem", value: "name", sortable: false }
    ]
  }),
  computed: {
    // Site Kategori seçenekleri (ağaç yapısında)
    siteCategoryItems() {
      const items = [{ key: null, name: "Tümü" }];
      
      // Kategorisiz seçeneği
      items.push({ key: "UNCATEGORIZED", name: "Kategorisiz" });
      
      // Store'dan gelen kategorileri al
      const categories = this.$store.state.categories.all || [];
      
      // Kategorileri levelDepth ve sortOrder'a göre sırala
      const sortedCategories = [...categories].sort((a, b) => {
        if (a.levelDepth !== b.levelDepth) return a.levelDepth - b.levelDepth;
        return a.sortOrder - b.sortOrder;
      });
      
      // Ağaç yapısında göstermek için recursive fonksiyon
      const buildTreeItems = (parentKey = null, prefix = "") => {
        const children = sortedCategories.filter(c => {
          const catParentKey = c.parentKey || c.ParentKey;
          if (parentKey === null) {
            return !catParentKey || catParentKey === "";
          }
          return catParentKey === parentKey;
        });
        
        children.forEach(category => {
          const catKey = category.categoryKey || category.CategoryKey;
          const catName = category.name || category.Name || catKey;
          if (catKey && catKey !== "UNCATEGORIZED") {
            items.push({
              key: catKey,
              name: prefix + catName,
              levelDepth: category.levelDepth || 0
            });
            // Alt kategorileri ekle
            buildTreeItems(catKey, prefix + "— ");
          }
        });
      };
      
      buildTreeItems(null, "");
      
      return items;
    },
    
    // Seçilen kategorinin tüm alt kategori key'lerini döndür
    getDescendantCategoryKeys() {
      if (!this.selectSiteCategory || this.selectSiteCategory === "UNCATEGORIZED") {
        return [];
      }
      
      const categories = this.$store.state.categories.all || [];
      const descendants = [this.selectSiteCategory];
      
      const findDescendants = (parentKey) => {
        categories.forEach(cat => {
          const catParentKey = cat.parentKey || cat.ParentKey;
          const catKey = cat.categoryKey || cat.CategoryKey;
          if (catParentKey === parentKey && catKey) {
            descendants.push(catKey);
            findDescendants(catKey);
          }
        });
      };
      
      findDescendants(this.selectSiteCategory);
      return descendants;
    },
    
    filteredProducts() {
      const allProducts = this.$store.state.products.all || [];

      const applyInstallment = (list) => {
        if (!this.onlyInstallment) return list;
        return list.filter(p => p.isInstallmentEnabled === true || p.IsInstallmentEnabled === true);
      };

      // Site kategori filtresi yoksa tüm ürünleri döndür
      if (!this.selectSiteCategory) {
        return applyInstallment(allProducts);
      }

      // Kategorisiz filtresi
      if (this.selectSiteCategory === "UNCATEGORIZED") {
        return applyInstallment(allProducts.filter(product => {
          const categoryKey = product.categoryKey || product.CategoryKey;
          return !categoryKey || categoryKey === "UNCATEGORIZED";
        }));
      }

      // Seçilen kategori ve tüm alt kategorilerini al
      const validKeys = this.getDescendantCategoryKeys;
      return applyInstallment(allProducts.filter(product => {
        const productCatKey = product.categoryKey || product.CategoryKey;
        return validKeys.includes(productCatKey);
      }));
    }
  },
  watch: {
    dialog(val) {
      val || this.close();
    }
  },

  created() {
    //this.initialize();
  },

  methods: {
    async onTenantChange() {
      if (this.selectedTenantId) {
      
        localStorage.setItem('selectedTenantId', this.selectedTenantId.toString());
        localStorage.removeItem('selectedMpId'); 
        
        // Kategorileri yeniden yükle
        await this.$store.dispatch("getAllCategories");
    
        this.$store.dispatch("products/clearProducts");
        this.initialize();
      } else {

        this.$store.dispatch("products/clearProducts");
      }
    },
    async initialize() {
      if (!this.selectedTenantId) {
        return; 
      }
      
      await this.$store.dispatch("products/searchProduct", {
        search: this.search,
        state: this.select.id,
        categoryId: this.selectCategory.id,
      });
    },
    editItem(item) {
      // this.$router.push({ name: "admin-product-detail", params: { id: item.id } });
      window.open("/admin/product/detail/"+item.id, '_blank');
    },

    deleteItem(item) {
      confirm("Silmek İstediğinizden Emin Misiniz?") &&
        this.$store.dispatch("products/deleteProduct", item);
    },
    changeSort(column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending;
      } else {
        this.pagination.sortBy = column;
        this.pagination.descending = false;
      }
    },
    getSiteCategoryText(item) {
      if (item && item.category && item.category.name) {
        return item.category.name;
      }
      const categoryKey = item ? (item.categoryKey || item.CategoryKey) : null;
      if (!categoryKey || categoryKey === "UNCATEGORIZED") {
        return "Kategorisiz";
      }
      // Store'dan kategori adını bul
      const categories = this.$store.state.categories.all || [];
      const category = categories.find(c => 
        (c.categoryKey || c.CategoryKey) === categoryKey
      );
      return category ? (category.name || category.Name) : categoryKey;
    }
  },
  async mounted() {

    this.$store.dispatch("products/clearProducts");
    
    // Kategorileri yükle
    await this.$store.dispatch("getAllCategories");
  
    const savedTenantId = localStorage.getItem('selectedTenantId');
    if (savedTenantId && savedTenantId !== '0') {
      this.selectedTenantId = parseInt(savedTenantId);
      await this.initialize();
    }
  },
  beforeDestroy() {

    localStorage.setItem('selectedTenantId', '0');
    localStorage.removeItem('selectedMpId');
    this.$store.dispatch("products/clearProducts");
  }
};
</script>

<style scoped>

.mobile-toolbar {
  padding: 16px;
}

.mobile-cards {
  padding: 8px;
}

.mobile-product-card {
  margin-bottom: 16px !important;
}

.product-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}

.table-wrapper {
  height: calc(100vh - 210px);
  overflow: auto;
}
.mobile-field {
  display: flex;
  flex-direction: column;
  margin-bottom: 8px;
}

.field-label {
  font-size: 12px;
  color: #666;
  font-weight: 500;
  margin-bottom: 2px;
}

.field-value {
  font-size: 14px;
  color: #333;
  font-weight: 400;
}

@media (max-width: 959px) {
  .mobile-toolbar .v-card__title {
    padding: 12px 16px;
  }
  
  .mobile-toolbar .v-card__text {
    padding: 0 16px 16px;
  }
}

@media (max-width: 600px) {
  .mobile-cards {
    padding: 4px;
  }
  
  .mobile-product-card {
    margin: 8px 4px !important;
  }
  
  .mobile-field {
    margin-bottom: 6px;
  }
}
</style>
